export const sizes = [
  { id: "< 100 HA", name: "< 100 HA" },
  { id: "> 100 HA", name: "> 100 HA" },
  { id: "> 400 HA", name: "> 400 HA" },
  { id: "> 1,000 HA", name: "> 1,000 HA" },
  { id: "> 5,000 HA", name: "> 5,000 HA" },
  { id: "> 10,000 HA", name: "> 10,000 HA" },
  { id: "> 50,000 HA", name: "> 50,000 HA" },
];
